export default __webpack_public_path__ + "static/media/portfolio-205.2d6a5d89.jpg";